module.exports = __webpack_public_path__ + "static/profile_pic-da1fb08b384bb7dc9cb368b75b371675.jpg";